import * as React from 'react';

function SvgRefresh(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
      <path d="M7 12.998a1 1 0 01.117 1.993L7 14.998H3.524l2.823 2.653a8 8 0 0013.2-2.987 1 1 0 011.886.668 10 10 0 01-7.22 6.417 9.99 9.99 0 01-9.03-2.44l-.228-.222L2 16.309v3.69a1 1 0 01-.883.992L1 20.998a1 1 0 01-.993-.883L0 19.998v-6.01l.002-.06-.002.07a1.01 1.01 0 01.196-.594 1.013 1.013 0 01.154-.166l-.079.075a1.01 1.01 0 01.612-.308l.02-.002.045-.004H7zm11.573-8.53l.243.22.229.221L22 7.687V3.998a1 1 0 01.883-.993L23 2.998a1 1 0 01.993.883l.007.117v6.021c0 .011 0 .023-.002.034L24 9.998a1.01 1.01 0 01-.2.6 1.018 1.018 0 01-.15.16l.079-.075a1.01 1.01 0 01-.612.308l-.012.002a1.006 1.006 0 01-.056.004l-.049.001h-6a1 1 0 01-.117-1.993L17 8.998h3.476l-2.823-2.653a8 8 0 00-13.2 2.987 1 1 0 01-1.886-.668 10 10 0 017.22-6.417 9.993 9.993 0 018.786 2.22z" />
    </svg>
  );
}

export default SvgRefresh;
